import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Contact\UpdateContactController::__invoke
* @see app/Http/Controllers/Contact/UpdateContactController.php
* @route '/api/contact/{contact}'
*/
const UpdateContactController = (args: { contact: string | number | { id: string | number } } | [contact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateContactController.url(args, options),
    method: 'put',
})

UpdateContactController.definition = {
    methods: ["put"],
    url: '/api/contact/{contact}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Contact\UpdateContactController::__invoke
* @see app/Http/Controllers/Contact/UpdateContactController.php
* @route '/api/contact/{contact}'
*/
UpdateContactController.url = (args: { contact: string | number | { id: string | number } } | [contact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { contact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            contact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contact: typeof args.contact === 'object'
        ? args.contact.id
        : args.contact,
    }

    return UpdateContactController.definition.url
            .replace('{contact}', parsedArgs.contact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Contact\UpdateContactController::__invoke
* @see app/Http/Controllers/Contact/UpdateContactController.php
* @route '/api/contact/{contact}'
*/
UpdateContactController.put = (args: { contact: string | number | { id: string | number } } | [contact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateContactController.url(args, options),
    method: 'put',
})

export default UpdateContactController